import styled from "styled-components";
import { TEXT_SECONDARY } from "@streeteasy/design-system/colors";
import { LARGE_SCREEN } from "@streeteasy/design-system/constants/screenSizes";
import colorPalette from "@streeteasy/design-system/deprecated/colors";

const InputWrapper = styled.input.attrs(props => ({
  disabled: props.isDisabled
}))`
  -webkit-font-smoothing: antialiased;
  -webkit-text-size-adjust: 100%;
  appearance: none;
  border-radius: 0;
  box-shadow: none;
  background: none;
  background-color: white;
  border: 1px solid ${colorPalette.foxGrey};
  box-sizing: border-box;
  caret-color: ${colorPalette.classicBlue};
  color: ${colorPalette.whaleGrey};
  font: 400 14px/18px "Source Sans Pro", Helvetica, Arial, Geneva, sans-serif;
  height: 40px;
  padding: 0 15px;
  width: 100%;
  ${props =>
    props.isDisabled &&
    `
    color: ${colorPalette.wolfGrey};
    background: ${colorPalette.mouseGrey};
    border-color: ${colorPalette.foxGrey};
  `}
  ${props =>
    props.isInvalid &&
    `
    background: rgba(237, 67, 47, 0.12);
    border-color: ${colorPalette.errorRed};
  `}

  @media screen and (max-width: 660px) {
    height: 45px;
  }

  &:focus {
    border: 1px solid
      ${props =>
        props.isInvalid ? colorPalette.errorRed : colorPalette.foxGrey};
  }

  &::-webkit-input-placeholder {
    color: ${TEXT_SECONDARY};
  }

  &::-moz-placeholder {
    color: ${TEXT_SECONDARY};
  }

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

InputWrapper.displayName = "InputWrapper";

export default InputWrapper;
